import request from '@/utils/request'


// 实时传感器数据查询
export function query(data) {
  return request({
    url: '/db/collect-detail/current-sensor-query',
    method: 'post',
    data
  })
}

//监控对象/ 节点数量查询
export function statusInfoQuery(data) {
  return request({
    url: '/db/collect-detail/status-info-query',
    method: 'post',
    data
  })
}